// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

import "./quotes-list.scss";

const quotesList = () => {
    let allQuotesList = document.querySelectorAll(".quotes-list");

    if (!allQuotesList.length) return;

    allQuotesList.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: "auto",

            breakpoints: {
                0: { slidesPerView: 1.1, spaceBetween: 20 },
                350: { slidesPerView: 1.1, spaceBetween: 20 },
                485: { slidesPerView: 1.2, spaceBetween: 20 },
                630: { slidesPerView: 1.6, spaceBetween: 20 },
                768: { slidesPerView: 1.8, spaceBetween: 20 },
                900: { slidesPerView: 2.1, spaceBetween: 20 },
                1025: { slidesPerView: 2.5, spaceBetween: 30 },
                1300: { slidesPerView: 3, spaceBetween: 30 },
            },

            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                clickable: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default quotesList;
